import { render } from "./DgWohnungStep9.vue?vue&type=template&id=203acc52&scoped=true"
import script from "./DgWohnungStep9.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep9.vue?vue&type=script&lang=js"

import "./DgWohnungStep9.vue?vue&type=style&index=0&id=203acc52&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203acc52"]])

export default __exports__